import { Footer, HomePage } from "./HomePage_Buttons";
import React from "react";
import "./App.css";
import {} from "react-bootstrap";

function App() {
  return (
    <>
      <div className="App">
        <HomePage></HomePage>
        <Footer></Footer>
      </div>
    </>
  );
}

export default App;
